import api from "../api/api";

export const MerchantService = {
  // Abunəliyi aktiv olan bütün mağazalar
  list: async () => {
    const response = await api.get("merchants");
    return response.data; // { merchants: [...] }
  },

  // Bir mağazanın detalı + aktiv kampaniyaları
  show: async (id) => {
    const response = await api.get(`merchants/${id}`);
    return response.data; // { merchant, quizzes }
  },
};
